import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import {
    Box,
    DaTable,
    DaTableBody,
    DaTableHeadCell,
    DaTableHead,
    Text,
} from '@paygreen/paygreen-ui';
import MemoizedRow from './MemoizedRow';

const CategoriesDaTable = ({
    t,
    data,
    isLoading,
    headerGroups,
    page,
    prepareRow,
    selectedRowIds,
    setModalData,
}) => (
    <Box>
        <DaTable
            blockWidth="none"
            isLoading={isLoading}
            loadingRowNumber={15}
            loadingMainCellNumber={3}
        >
            {headerGroups.map((headerGroup) => (
                <DaTableHead
                    blockTitle={t('user.list.table.title')}
                    {...headerGroup.getHeaderGroupProps()}
                >
                    {headerGroup.headers.map((column, index) => (
                        <DaTableHeadCell
                            key={index}
                            label={column.render('Header')}
                        >
                            {index === 1 ? column.render('Filter') : null}
                        </DaTableHeadCell>
                    ))}
                </DaTableHead>
            ))}

            <DaTableBody>
                {!isLoading && data.length && page.length ? (
                    page.map((row) => {
                        prepareRow(row);

                        const isActive = Object.keys(selectedRowIds).includes(
                            row.id,
                        );

                        return (
                            <MemoizedRow
                                key={row.id}
                                row={row}
                                data={data}
                                setModalData={setModalData}
                                className="DaTableRow"
                                isActive={isActive}
                                {...row.getRowProps()}
                            />
                        );
                    })
                ) : (
                    <Text
                        align="center"
                        marginTop="xl"
                        marginBottom="xl"
                        textSize="sm"
                    >
                        {t('noDataFound')}
                    </Text>
                )}
            </DaTableBody>
        </DaTable>
    </Box>
);

CategoriesDaTable.propTypes = {
    data: PropTypes.array.isRequired,
    isLoading: PropTypes.bool,
    headerGroups: PropTypes.array.isRequired,
    page: PropTypes.array.isRequired,
    prepareRow: PropTypes.func.isRequired,
    selectedRowIds: PropTypes.object,
    handleRefreshData: PropTypes.func,
    setModalData: PropTypes.func,
};

CategoriesDaTable.defaultProps = {
    isLoading: false,
};

export default withTranslation('common')(CategoriesDaTable);
